export class AddViewGuestInput {
    userSgunId: number
    guestId: number
    guestSgunId: number
}
